import React from 'react';

const AppleIcon: React.FC = React.memo(() => (
  <svg
    className="social-button-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M17.05 12.536c-.03-2.77 2.26-4.1 2.36-4.164-1.287-1.883-3.29-2.14-4-2.165-1.7-.172-3.32 1-4.18 1-.86 0-2.19-.976-3.6-.95-1.85.027-3.56 1.076-4.51 2.733-1.93 3.344-.49 8.29 1.38 11.003.92 1.33 2.01 2.82 3.44 2.767 1.38-.056 1.9-.892 3.57-.892 1.66 0 2.13.892 3.59.865 1.48-.027 2.42-1.354 3.33-2.69 1.05-1.542 1.48-3.038 1.5-3.114-.03-.014-2.88-1.106-2.91-4.387zM14.28 3.9c.76-.923 1.27-2.205 1.13-3.482-1.09.044-2.42.726-3.2 1.648-.7.816-1.31 2.122-1.15 3.374 1.22.095 2.46-.618 3.22-1.54z"
    />
  </svg>
));

AppleIcon.displayName = 'AppleIcon';

export default AppleIcon;
